/**
 * `duration`/`closeTimeout` as the older APIs expressed it. Note the inversion:
 * omitting it gets the standard 5s, and `false`/`null` is the persistent opt-out
 * — the old components only auto-closed on a positive integer.
 */
export type SnackbarDuration = number | false | null | undefined;

export const toAutoHideDuration = (
  duration: SnackbarDuration
): number | null | undefined => {
  if (duration === undefined) return undefined;
  if (duration === null || duration === false) return null;
  return Number.isInteger(duration) && duration > 0 ? duration : null;
};
